// extracted by mini-css-extract-plugin
export default {"main":"HomeHero_main__iyV-M","text":"HomeHero_text__+jNDW"};